var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.414 19H0v-5.414L11.879 1.707c1.171-1.171 3.07-1.171 4.242 0l1.172 1.172c1.171 1.171 1.171 3.07 0 4.242L16.414 8l-11 11zM11 5.413L2 14.414V17h2.584l9.001-9-2.586-2.587zm3.708-2.292c-.39-.39-1.024-.39-1.414 0L12.414 4l2.585 2.585.88-.877c.33-.33.381-.835.152-1.218l-.07-.102-.082-.094z",
    transform: "translate(-1288 -248) translate(1288 248) translate(5 2)"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.711b1439.svg";
export { ForwardRef as ReactComponent };